import httpManager from "../../util/common"
import china_area_code from "../../../static/json/100000_full_geo.json"
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
export default {
    data() {
        return {
            report_date: '',
            industry: 'D44',
            report_date_options: [],
            map_data: [],
            map: null,   //地图对象
            geo_layer: null,  //地域块对象
            info_control: null, //地图右上角信息控件,
            point_json: null, //地图标记数据
            loading: false,
            current_year: (new Date()).getFullYear(),
            current_month: (new Date()).getMonth()
        }
    },
    methods: {
        // 清除筛选条件
        clearOptions() {
            const { current_month, current_year } = this
            this.report_date = current_month <= 2 ? current_year - 2 : current_year - 1
            this.industry = 'D44'
            this.getMapData()
        },
        // 设置日期
        setReportDate() {
            const { current_month, current_year } = this
            this.report_date = current_month <= 2 ? current_year - 2 : current_year - 1
            this.report_date_options.push(current_year - 1)
            this.report_date_options.push(current_year - 2)
            this.report_date_options.push(current_year - 3)
            this.report_date_options.push(current_year - 4)
        },
        getMapData() {
            let self = this
            self.data = null
            let params = new Map()
            // params.set("lang", this.$i18n.locale)
            if (self.report_date) {
                params.set("year", self.report_date)
            }
            self.loading = true
            httpManager('carbon_map', params)
            .then(response => {
                self.map_data = response.data.data
                self.leafletMap()
                self.loading = false
            }).catch(error => {
                console.log(error)
                self.loading = false
            })
        },
        leafletMap() {
            if (!this.map) {
                this.map = L.map('carbon-map-svg', {
                    center: [35, 115],
                    zoom: 3,
                    zoomControl: false,
                    doubleClickZoom: false,
                })

                this.initInfoControl()
                this.info_control.addTo(this.map)
            } else {
                this.map.removeLayer(this.geo_layer)
            }
            this.geo_layer = L.geoJSON(china_area_code, {
                style: this.style,
                onEachFeature: this.onEachFeature
            }).addTo(this.map)

            // 禁用缩放与拖拽
            // this.map.scrollWheelZoom.disable()
            // this.map.dragging.disable()
        },
        // 地图获取颜色，在style中调用
        getColor(adcode) {
            let color = '#f5f5f5'
            for(let i in this.map_data) {
                if (this.map_data[i].district_code == adcode){
                    let attr = this.industry.toLowerCase()
                    let value = this.map_data[i][attr]
                    if(value <= 50 || !value) {
                        return '#76ca44'
                    } else if(value <= 200) {
                        return '#a6d58e'
                    } else if(value <= 400) {
                        return '#79b0e6'
                    } else if(value <= 1000) {
                        return '#edb1b1'
                    } else {
                        return '#de3e3e'
                    }
                }
            }
            
            return color;
        },
        // 地图获取样式
        style(feature) {
            return {
                fillColor: this.getColor(feature.properties.adcode),
                weight: 2,
                opacity: 1,
                color: '#9a9a98',
                dashArray: '3',
                fillOpacity: 1
            }
        },
        // 初始化地图右上角信息控件
        initInfoControl() {
            this.info_control = L.control()
            this.info_control.onAdd = function (map) {
                this._div = L.DomUtil.create('div', 'carbon-map-info'); // create a div with a class "info"
                this.update();
                return this._div;
            }
            this.info_control.update = function (props) {
                let name = props ? props.name : "中华人民共和国"
                this._div.innerHTML = '<h4>China</h4>' +
                    '<b>' + name + '</b><br />'
            }
        },
        // 地图相关事件
        onEachFeature(feature, layer) {
            layer.on({
                mouseover: this.highlightFeature,
                mouseout: this.resetHighlight,
            })
        },
        // 地图触碰高亮，在onEachFeature中调用
        highlightFeature(e) {
            var layer = e.target

            layer.setStyle({
                weight: 1,
                color: '#fff',
                dashArray: '',
                fillOpacity: 1,
                className: 'geo-json-map'
            })
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                layer.bringToFront()
            }

            this.info_control.update(layer.feature.properties)
        },
        // 地图移除高亮，在onEachFeature中调用
        resetHighlight(e) {
            this.geo_layer.resetStyle(e.target);
            this.info_control.update()
        },
        // 地图点击放大板块，在onEachFeature中调用
        zoomToFeature(e) {
            this.map.fitBounds(e.target.getBounds())
        }
    },
    created() {
        this.setReportDate()
    },
    mounted() {
        this.getMapData()
    },
    computed: {
        legends() {
            return [
                { name: '0-50', color: '#76ca44' },
                { name: '51-200', color: '#a6d58e' },
                { name: '201-400', color: '#79b0e6' },
                { name: '401-1,000', color: '#edb1b1' },
                { name: '>1,000', color: '#de3e3e' },
            ]
        },
        carbon_industry_options() {
            return [
                { label: this.$t('carbon.generate_electricity'), value: 'D44' },
                { label: this.$t('carbon.iron_steel'), value: 'C31' },
                { label: this.$t('carbon.chemical'), value: 'C26' },
                { label: this.$t('carbon.building_materials'), value: 'C30' },
                { label: this.$t('carbon.civil_aviation'), value: 'G56' },
                { label: this.$t('carbon.petrochemical'), value: 'C25' },
                { label: this.$t('carbon.colored'), value: 'C32' },
                { label: this.$t('carbon.papermaking'), value: 'C22' },
            ]
        },
    }
}


// WEBPACK FOOTER //
// ./src/carbon/js/carbon_map.js